import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { MobileNav } from "../mobile-nav";
import { SideNav } from "./side-nav";
import { TopNav } from "./top-nav";
import { useMobileNav } from "./use-mobile-nav";
import { useMobile } from "src/hooks/use-mobile";
import { NoticeProvider } from "src/components/notice-provider";

const TOP_NAV_HEIGHT = 64;
const SIDE_NAV_WIDTH = 280;

const VerticalLayoutRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  height: `calc(100vh - ${TOP_NAV_HEIGHT}px)`,
  [theme.breakpoints.up("desktop")]: {
    paddingLeft: SIDE_NAV_WIDTH,
  },
  minHeight: 0, // ✅ 추가
  minWidth: 0, // ✅ 추가 (가끔 가로도 필요)
}));

const VerticalLayoutContainer = styled("div")({
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  minHeight: 0, // ✅ 추가
  minWidth: 0, // ✅ 추가 (가끔 가로도 필요)
});

export const VerticalLayout = (props) => {
  const { children, sections, navColor } = props;
  const isMobile = useMobile();
  const mobileNav = useMobileNav();

  return (
    <>
      <TopNav onMobileNavOpen={mobileNav.handleOpen} />
      {!isMobile && (
        <SideNav
          color={navColor}
          sections={sections}
        />
      )}
      {isMobile && (
        <MobileNav
          color={navColor}
          onClose={mobileNav.handleClose}
          open={mobileNav.open}
          sections={sections}
        />
      )}
      <VerticalLayoutRoot>
        <NoticeProvider>
          <VerticalLayoutContainer>
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, minWidth: 0 }}>{children}</Box>
          </VerticalLayoutContainer>
        </NoticeProvider>
      </VerticalLayoutRoot>
    </>
  );
};

VerticalLayout.propTypes = {
  children: PropTypes.node,
  navColor: PropTypes.oneOf(["blend-in", "discreet", "evident"]),
  sections: PropTypes.array,
};
